import { CustomsPingService } from './ping';
import { DnsService } from './dns';

export class CustomsService {
  public static Ping = CustomsPingService;
  public static Dns = DnsService;
}
